var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notfound"}},[_c('div',{staticClass:"notfound"},[_vm._m(0),_c('h1',[_vm._v("oops!")]),_c('h2',[_vm._v("Page non trouvée")]),_c('router-link',{attrs:{"to":"/my-account"}},[_vm._v("Revenir à l'accueuil")]),_c('div',{staticClass:"notfound-social"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-bg"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }